<li fxLayout>
  <ng-content select="[left-column]"></ng-content>
  <ng-content select="[right-column]"></ng-content>
</li>
